var __TEMP__ = require('./_arrayPush.js');var arrayPush = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getPrototype.js');var getPrototype = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getSymbols.js');var getSymbols = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./stubArray.js');var stubArray = __REQUIRE_DEFAULT__(__TEMP__);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getSymbolsIn;
